import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                position: "fixed",
                bottom: 0,
                backgroundColor: "white",
                width: "100%",
                zIndex: 1000,
                boxShadow:
                    "0px -2px 2px -2px rgba(0, 0, 0, 0.2), 0px -4px 2px -1px rgba(0, 0, 0, 0.14)",
                //padding: theme.spacing(2),
                height: theme.relode.sizes.mobileFooterHeight,
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                padding: theme.spacing(0, 2),
            },
        }),
    { name: "MobileFooter" }
);

interface MobileFooterProps {
    children?: React.ReactNode;
}
export const MobileFooter = (props: MobileFooterProps) => {
    const classes = useStyles(props);
    if (!props.children) return null;
    return <div className={classes.root}>{props.children}</div>;
};
